import { DependencyList, useMemo } from "react";

/**
 * Returns a computed value, recomputing when any of the triggers change
 * - similar to useMemo() but recompute is controlled by triggers which are independent of compute() dependencies
 * - compute() should be side-effect-free in order to be safe for concurrent-rendering
 * - triggers are shallow-compared to determine if the hook should recompute
 */
export function useComputedValue<T>(
  compute: () => T,
  triggers: DependencyList,
): T {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(compute, triggers);
}
